var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "skeleton max-w-full",
    class: _vm.roundedString,
    style: {
      height: _vm.computedHeight,
      width: _vm.computedWidth
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }